import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "sealCheck"
const SealCheckIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m22 11.51-2.218-2.528.309-3.346-3.282-.745L15.091 2 12 3.327 8.91 2 7.19 4.89l-3.28.737.308 3.346L2 11.509l2.218 2.527-.309 3.355 3.282.745 1.718 2.891L12 19.691l3.09 1.327 1.72-2.89 3.28-.746-.308-3.346L22 11.51Zm-11.818 4.545-3.637-3.637 1.282-1.282 2.355 2.346 5.99-5.991 1.282 1.29-7.272 7.274Z"
          />
        </svg>
      }
    </span>
  )
}
export default SealCheckIcon
